
import './Gridd.css'
import background from '../images/Background.png'
import nap1 from '../images/nap1.jpg'
import nap2 from '../images/nap2.jpg'
import nap3 from '../images/nap3.jpg'
import nap4 from '../images/nap4.jpg'
import nap5 from '../images/nap5.jpg'
import c1 from '../images/c1.png'
import t1 from '../images/t1.jpg'
import t2 from '../images/t2.jpg'
import t3 from '../images/t3.jpg'
import h1 from '../images/h1.png'
import { RiInstagramFill } from "react-icons/ri";
import { FaFacebookF } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { IoMenu } from "react-icons/io5";
const Gridd=()=>{
    return(
        <>
        <header>
            <a className='logo' href="">QWE<span>RY</span></a>
            <ul className='navbar-center'>
                <li><a href="">Home</a></li>
                <li><a href="">Iformation</a></li>
                <li><a href="">About Us</a></li>
                <li><a href="">Culture</a></li>
                <li><a href="">Contatic Us</a></li>
            </ul>
            <div>
                <ul className='navbar-end' style={{color:'white'}} >
                    <li><a href="">Follow us</a></li>
                    <li><a href=""><RiInstagramFill /></a></li>
                    <li><a href=""><FaFacebookF /></a></li>
                    <li><a href=""><FaTwitter /></a></li>
                </ul>
                <IoMenu className='toggle'/>
            </div>
        </header>
        <section className='home'>
            <div className="home-text">
                <span>LET'S.</span>
                <h1>Plannig Your Own Traver</h1>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid, voluptatum laboriosam. Sint alias id illum.</p>
                <button className='home-btn'>Book Trip</button>
            </div>

        </section>
       
       
            <div className="container">
            <div className='servicesss'>
            <div className='servee'>
                <img src={nap1} alt="" />
                <h6>maison</h6>
            </div>
            <div className='servee'>
                <img src={nap2} alt="" />
                <h6>maison</h6>
            </div>
            <div className='servee'>
                <img src={nap3} alt="" />
                <h6>maison</h6>
            </div>
            <div className='servee'>
                <img src={nap4} alt="" />
                <h6>maison</h6>
            </div>
            <div className='servee'>
                <img src={nap5} alt="" />
                <h6>maison</h6>
            </div>

        </div>
            </div>

            <div className="container">
              <div className='content'>
                <img src={c1} alt="" />
                <div className='content-text'>
                    <span>East nosa Tenngd</span>
                    <h2>Have You Enjoyed your Holiday</h2>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil, praesentium maiores veniam debitis, autem odio consectetur inventore sequi iusto dignissimos laudantium rerum doloremque illum voluptates corrupti nesciunt harum quaerat eaque.</p>
                    <button className='content-btn'>Book Trip</button>
                </div>
              </div>
            </div>
     
       <div className="container">
       
            <h1 className='travel-header'>Popular Tours</h1>
        
        <div className='tours'>
            <div className='tour'>
            <img src={t1} alt="" />
            <div className='text-tour'>
                <span>East Java</span>
                <h6>Mount Bromp</h6>

            </div>
            </div>
            <div className='tour'>
            <img src={t2} alt="" />
            <div className='text-tour'>
                <span>East Java</span>
                <h6>Mount Bromp</h6>

            </div>
            </div>
            <div className='tour'>
            <img src={t3} alt="" />
            <div className='text-tour'>
                <span>East Java</span>
                <h6>Mount Bromp</h6>

            </div>
            </div>
          
        </div>
        <div className='div-btn'>
        <button className='btn-tours'>See Tours</button>
        </div>
       
       </div>
       <div className="container">
              <div className='content'>
              <div className='content-text'>
                    <span>East nosa Tenngd</span>
                    <h2>Have You Enjoyed your Holiday</h2>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil, praesentium maiores veniam debitis, autem odio consectetur inventore sequi iusto dignissimos laudantium rerum doloremque illum voluptates corrupti nesciunt harum quaerat eaque.</p>
                    <button className='content-btn'>Book Trip</button>
                </div>
                <img src={h1} alt="" />
             
              </div>
            </div>
   <div className="container">
    <div className='explor'>
        <div className='explor-text'>
            <h1>Ready to explore?</h1>
            <p>Lets go to vervication, Make your day</p>
        </div>
        <div className='explor-form'>
            <input type="email"  placeholder='Enter Your Email....'/>
            <button className='submit'>Get Started</button>
            </div>

    </div>
   </div>
   <div className="container">
    <div className='footer'>
        <ul className='other'>
            <li>Services</li>
            <li>Email Marketig</li>
            <li>Comparing</li>
            <li>Pranding</li>
            <li>Offline</li>
        </ul>
        <ul className='other'>
        <li>Apout</li>
            <li>Email Marketig</li>
            <li>Comparing</li>
            <li>Pranding</li>
            <li>Offline</li>
        </ul>
        <ul className='other'>
        <li>Help</li>
            <li>FAQ</li>
            <li>Contact Us</li>
            
        </ul>
        <div>
        <span>Social</span>
        <ul className='social' style={{color:'white'}} >
                    <li><RiInstagramFill /></li>
                    <li><FaFacebookF /></li>
                    <li><FaTwitter /></li>
                </ul>
        </div>
       
    </div>
    <div className='copy'>
        <span>Copyright 2024 Maisoon Ahmed</span>
    </div>
   </div>
 
        </>
    )
}
export default Gridd;